export default [
    {
        path: "view-coupon/:coupon_id/claims",
        name: "MultipleCouponsClaims",
        meta:{
            permissionPath: 'coupons.multiple.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "viewCouponClaims" */ "@/views/loyaltyPanel/multipleCoupons/ViewCouponClaims"
            ),
    },  
];
